import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  upsellTitle: {
    defaultMessage: 'Get Bundles',
    id: 'Wzxlxn',
    description: 'Title of the Kits and Bundles Upsell Banner.',
  },
});
